import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles({
    root: {
        height: "100%",
        flexGrow: 1,
    },
});